<template lang="pug">
  v-layout(row justify-center)
    v-dialog(data-cy="remove-modal.dialog" :value="value" @input="$emit('input')" persistent max-width="540")
      v-card
        title-bar(data-cy="remove-modal.title" dark)
          template(v-if="useResourceAsTitle") {{ resource }}
          template(v-else-if="isEditingResourceStatus") Mark {{ resource }} as {{ action }}?
          template(v-else) {{ action }} {{ resource }}?
        v-card-text
          span.message {{ confirmationMessage }}
          v-radio-group(v-model="deleteType" v-if="shouldShowOptions")
            v-radio(:label="onlyThisResource", :value="1")
            v-radio(:label="thisAndFollowingResource", :value="2")
            v-radio(:label="allResources", :value="3")
        v-card-actions
          v-spacer
          v-btn(data-cy="remove-modal.cancel" flat @click="closeDialog(false)") Cancel
          v-btn.primary(data-cy="remove-modal.submit" @click="closeDialog(true)" :disabled="isDisabled") OK
</template>

<script>

import TitleBar from '@/Core/components/TitleBar';

const single = "single"

export default {
  components: {
    TitleBar,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isV21: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'delete',
    },
    useResourceAsTitle: {
      type: Boolean,
      default: false,
    },
    resourceSingular: {
      type: String,
    },
    resourcePlural: {
      type: String,
    },
    removeAmount: {
      type: String,
      default: 'single',
    },
    singleAmountMessage: {
      type: String,
      default: null,
    },
    multipleAmountMessage: {
      type: String,
      default: null,
    },
    itemTask: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      deleteType: 0,
    }
  },

  computed: {
    shouldShowOptions() {
      return this.itemTask != null && this.itemTask.isRecurrent;
    },
    onlyThisResource() {
      return "This " + this.resource;
    },
    thisAndFollowingResource() {
      return "This and following  " + this.resource;
    },
    allResources() {
      return "All  " + this.resource;
    },
    resource() {
      return this.removeAmount === single ? this.resourceSingular : this.resourcePlural;
    },
    isEditingResourceStatus() {
      return ['complete', 'incomplete'].includes(this.action);
    },
    defaultSingleAmountMessage() {
      if (this.isEditingResourceStatus) {
        return `Are you sure you want to mark this ${this.resourceSingular} as ${this.action}?`;
      }
      return `Are you sure you want to ${this.action} this ${this.resourceSingular}?`;
    },
    defaultMultipleAmountMessage() {
      if (this.isEditingResourceStatus) {
        return `Are you sure you want to mark these ${this.resourcePlural} as ${this.action}?`;
      }
      return `Are you sure you want to ${this.action} these ${this.resourcePlural}?`;
    },
    confirmationMessage() {
      if (this.removeAmount === single) {
        return this.singleAmountMessage || this.defaultSingleAmountMessage;
      } else if (this.removeAmount === 'multiple') {
        return this.multipleAmountMessage || this.defaultMultipleAmountMessage;
      }
    },
    isDisabled() {
      return this.itemTask && this.itemTask.isRecurrent && this.deleteType <= 0;
    }
  },
  watch: {
    deleteType(value) {
      this.$emit('setDeleteType', value)
    },
  },

  methods: {
    closeDialog(isResourceRemoved = false) {
      this.$emit('input', false);
      this.$emit('close', isResourceRemoved);
      this.deleteType = 0;
    },
  },
};

</script>

<style lang="scss" scoped>
.message {
  white-space: pre-wrap;
}
</style>
